import React from 'react';
import { Icon, Card } from '@tcc/crate';

import { getMessage } from '../../i18n/i18nWrapper';

import styles from './css/shared.css';

const VerificationPending = () => (
  <div className={styles.container}>
    <Card className={styles.card}>
      <div data-test-id="climate-fv-logo">
        <Icon className={styles.logo} glyph={Icon.set.CLIMATE_PORTAL_COLOR} />
      </div>
      <p className={styles.message} data-test-id="verification-pending-message">
        {getMessage('verificationPending.blurb')}
      </p>
    </Card>
  </div>
);

export default VerificationPending;
